import { useEffect } from 'react';
import JobCreateViewLayout from '../layout';
import JobDetailsTab from '../tabs/job-details';
import AutopilotWorkflow from '../tabs/autopilot-workflow';
import { useJobCreationContext } from '../hooks/use-job-creation-context';
import Launch from '../tabs/launch';

export default function JobCreateView() {
  // hooks
  const { currentState, JOB_CREATION_STATES } = useJobCreationContext();

  // effects
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentState]);

  return (
    <JobCreateViewLayout>
      {currentState === JOB_CREATION_STATES.JOB_DETAILS.value && (
        <JobDetailsTab />
      )}
      {currentState === JOB_CREATION_STATES.AUTOPILOT_WORKFLOW.value && (
        <AutopilotWorkflow />
      )}
      {currentState === JOB_CREATION_STATES.LAUNCH.value && <Launch />}
    </JobCreateViewLayout>
  );
}
